<base-site-layout
    [heading]="'Liefertermin für alle Positionen' | translate"
    headerIcon="fas fa-calendar-day"
    [isDialog]="true"
    (dialogCloseClicked)="cancel()"
>
    <div class="px-3">
        <form [formGroup]="form">
            <div class="row mb-3">
                <div class="col-12 col-md-6">
                    <iim-datepicker
                        formControlName="desiredDeliveryDate"
                        [minDate]="data.minDate"
                        [placeholder]="'Liefertermin' | translate"
                    ></iim-datepicker>
                </div>
            </div>
            <div class="row justify-content-end">
                <div class="col-auto mb-2">
                    <div class="btn-group btn-group-sm">
                        <button type="button" class="btn btn-secondary" (click)="cancel()">
                            {{ 'Abbrechen' | translate }}
                        </button>
                        <button type="button" class="btn btn-primary" (click)="save()" [disabled]="form.invalid">
                            {{ 'Übernehmen' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</base-site-layout>
